import { defineSlotRecipe } from '@chakra-ui/react'

/** Shared styling for the compact, hover-expandable slide navigation rail. */
export const assiduousSlideRailRecipe = defineSlotRecipe({
  className: 'assiduous-slide-rail',
  slots: [
    'root',
    'track',
    'item',
    'marker',
    'previewPanel',
    'previewAction',
    'previewTitle',
    'previewViewport',
    'previewCanvas',
  ],
  base: {
    root: {
      display: { base: 'none', xl: 'block' },
      position: 'fixed',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 998,
    },
    track: {
      alignItems: 'center',
      bg: 'transparent',
      gap: '7px',
      position: 'relative',
      px: '6px',
      py: 3,
      transition: 'width 220ms cubic-bezier(0.16, 1, 0.3, 1)',
    },
    item: {
      borderRadius: '3px',
      h: '24px',
      justifyContent: 'flex-start',
      minW: 0,
      p: 0,
      _hover: { bg: 'transparent' },
    },
    marker: {
      borderRadius: 'full',
      flexShrink: 0,
      height: '3px',
      transformOrigin: 'left center',
      transition:
        'transform 140ms cubic-bezier(0.16, 1, 0.3, 1), background-color 120ms ease',
      width: '52px',
      willChange: 'transform, background-color',
      _motionReduce: {
        transition: 'none',
      },
    },
    previewPanel: {
      bg: '#2D2D2B',
      border: '1px solid',
      borderColor: '#454542',
      borderRadius: '16px',
      boxShadow: '0 18px 44px rgba(0, 0, 0, 0.38)',
      overflow: 'hidden',
      position: 'absolute',
      top: '50%',
      transformOrigin: 'left center',
      transition:
        'left 180ms cubic-bezier(0.16, 1, 0.3, 1), opacity 140ms ease, transform 140ms cubic-bezier(0.16, 1, 0.3, 1), visibility 140ms ease',
      willChange: 'transform, opacity',
      width: '340px',
    },
    previewAction: {
      borderRadius: '16px',
      color: '#F4F4F4',
      cursor: 'pointer',
      display: 'block',
      p: 0,
      textAlign: 'left',
      transition: 'background 160ms ease',
      width: 'full',
      _hover: { bg: '#343432' },
    },
    previewTitle: {
      color: '#F4F4F4',
      fontSize: 'md',
      fontWeight: 'semibold',
    },
    previewViewport: {
      bg: '#F7F8F8',
      border: '1px solid',
      borderColor: '#555552',
      borderRadius: '10px',
      height: '176px',
      mx: 3,
      mb: 3,
      overflow: 'hidden',
      position: 'relative',
    },
    previewCanvas: {
      bg: 'white',
      height: '585px',
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      transform: 'scale(0.3)',
      transformOrigin: 'top left',
      width: '1040px',
    },
  },
})
